// Layout constants shared between the dashboard screen and the Program cards.
//
// Previously exported from app/(private)/(Dashboard)/dashboard.tsx, which imports
// those very cards -- a require cycle. SPACING is itself dependency-free.
import { SPACING } from '../config/designSystem/Spacing';

export const HORIZONTAL_MARGIN_DASHBOARD = SPACING['sp-16'];
export const MARGIN_BETWEEN_CARDS = SPACING['sp-16'];
